module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldShowReflectiontips) ? _c('a', {
    staticClass: "button-rounded button-rounded--reflection button-rounded--teachertips",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflectiontips(_vm.assignment)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--reflection"
  }), _vm._v("reflection")]) : _vm._e(), _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group,
      "isExcerpt": false,
      "isInspecting": _vm.isInspecting
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": _vm.prevStepLink
    }
  }, [_vm._v("Vorige stap")]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1110c9c2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/StepGroup.vue
// module id = fBeb
// module chunks = 1